import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { LeagueProps } from '../../../../../types';
import ProgressBar from '../../SharedComponents/ProgressBar/ProgressBar';
import styles from './styles.module.scss';
import WhoIsPlaying from '../WhoIsPlaying/WhoIsPlaying';

const cx = classNames.bind(styles);

const PickupDetailsCard = ({ league, currentUserId }) => {
  const active = new Date() >= new Date(league?.registration?.registration_open);
  const minFilled = league?.registrantCount >= league?.registration?.minSize;
  const maxFilled = league?.registrantCount >= league?.registration?.maxSize;
  const iconHeight = '20px';
  const iconWidth = '20px';
  const activePhaseText = 'Registration Open';
  const minPhaseText = `Minimum Required (${league?.registration?.minSize})`;
  const maxPhaseText = 'Team Complete';

  return (
    <div className={cx('programBox', 'p-2 m-2 mt-4')}>
      <div className="row">
        <div className={cx('programTitle', 'col-7')}>Who&apos;s Playing?</div>
        <div className="col-5">
          {league?.registrantCount}/{league?.registration?.maxSize} players registered
        </div>
      </div>
      <ProgressBar
        {...{
          active,
          minFilled,
          maxFilled,
          activePhaseText,
          minPhaseText,
          maxPhaseText,
          iconHeight,
          iconWidth,
        }}
      />
      {currentUserId ? (
        <>
          <div className={cx('separator-line', 'col-11 mb-3')} />
          <WhoIsPlaying />
        </>
      ) : null}
    </div>
  );
};
PickupDetailsCard.propTypes = {
  league: LeagueProps,
  currentUserId: PropTypes.string,
};

PickupDetailsCard.defaultProps = {
  league: null,
  currentUserId: undefined,
};

export default PickupDetailsCard;
